import { createFileRoute } from '@tanstack/react-router';

import Loading from '@/_pages/settings/countries/new/loading';

export const Route = createFileRoute('/_private/settings/countries/new')({
  component: Loading,
});
